function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJenkins = function SvgJenkins(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 226 312"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M177.718 129.264c0-49.429-39.175-89.5-87.5-89.5-48.324 0-87.5 40.071-87.5 89.5s39.176 89.501 87.5 89.501c48.325 0 87.5-40.071 87.5-89.501",
    style: {
      fill: "#d33833",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.284 107.098s-6.334 93.333 79.666 96l-6 10-46.666-15.667-13.333-15.333-11.667-22.334-6.667-26 2-17.333",
    style: {
      fill: "#ef3d3a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.288 190.319C14.936 174.611 5.436 152.923 5.436 128.93c0-23.988 9.5-45.679 24.852-61.384C45.648 51.841 66.815 42.15 90.217 42.15s44.571 9.691 59.929 25.396c15.351 15.705 24.853 37.396 24.853 61.384 0 23.993-9.502 45.681-24.853 61.389-15.358 15.702-36.527 25.393-59.93 25.395-23.4-.002-44.568-9.693-59.928-25.395M26.402 63.747C10.087 80.433 0 103.493 0 128.93c0 25.441 10.087 48.499 26.402 65.186 16.312 16.69 38.892 27.035 63.815 27.032 24.923.003 47.505-10.342 63.814-27.032 16.317-16.687 26.405-39.747 26.403-65.186.002-25.437-10.086-48.497-26.403-65.183-16.309-16.69-38.891-27.033-63.814-27.033S42.714 47.058 26.402 63.747",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.051 128.768-13.334-2-18-2-11.667-.333-11.333.333-8.667 2.667-7.667 8.333-6 17-1.333 3.667-8 2.666-4.667 7.667-3.333 11 3.667 9.667 8.666 3 7-3.334 3.334-7.333 4 .667 1.333 1.666-1.333 7.667-.334 9.667 2 13.333-.078 7.616 6.078 9.717 10.667 7.667 18.667 8 20.666-3 18-13 8.334-13.333 5.333-9.667 1.333-24-4-20.667-7.333-18.333-7-9.667",
    style: {
      fill: "#f0d6b7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.717 71.102-47.667-2v-8l4-28-2-2.334-33.333 11.334-2.334 4-3.333 37.666-7.666 22.667-1.667 5.333 26.666 18.333 8.334 3.334 7.333-9 6.333-5.667 7.334-2.333 3.333-1 4-17.333 3-3.667 7.667 2.667-5.334-10.334 29-13.666z",
    style: {
      fill: "#335061",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.717 187.435 8.666 3 7-3.334 3.334-7.333 4 .667 1 4-2 7.666 2 18.334-1.667 10 6 7 13 10.333-3.667 5-18.333-9-7.667-6-4.333-9.333-6.667-9-2-10.667z",
    style: {
      fill: "#6d6b6d",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.383 218.768s5 12.333 25 18.333 1 4.334 1 4.334l-21.666-8.334-8.334-8.333-3.666-6.667zM40.383 189.768s-7 23.334 19.667 26.667l-1 4-18.333-4.334-5.334-17.333 1.334-11.333z",
    style: {
      fill: "#dcd9d8",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.05 158.768 4.364 4.229s1.97-.229 2.303-2.562c.333-2.334 1.333-23.334 15.666-34.668 1.307-1.034-10.666 1.668-10.666 1.668L52.05 144.101M112.385 165.101s.777 10.104 3.498 9.327 2.721-3.498 2.721-3.498-6.608-4.275-6.219-5.829",
    style: {
      fill: "#f7e4cd",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.05 202.101s-5.494-1.16-6-6c-.506-4.841 6-1 7-.667M99.717 201.767s-7.334-1-7.334-5.666 8.334-4.334 10.667-2.334",
    style: {
      fill: "#f7e4cd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.383 180.101s-12.667 7.667-14 .333-4.334-12.667 2-20.333l-4.333 1.333-4 10.333-1.333 10 7.666 8.001 8.667-.667 5-4zM60.383 201.101s5.667 29.333 34.334 35c23.601 4.665 35.999-1 40.666-6.333 0 0-21 24.999-41 17.333s-34.666-21.667-34.333-30.666c.567-15.328.333-15.334.333-15.334M137.717 226.435s-9.666.333-10-8.334c0 0-.001-1.333.666-2.666 0 0 7.668 8.667 12.334 4",
    style: {
      fill: "#f7e4cd",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.389 214.532s-1.664 13.303-13.006 5.569c-7.333-5-6.666-12-5.333-13.333s.97-4.019 1.985-2.176.68 7.843 4.348 9.509 9.678 3.529 12.006.431",
    style: {
      fill: "#f7e4cd",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.05 124.435-31.333-14s13-51.667 6.333-67.667l-4.667 1.666-.333 19.667-8.666 37.333-3.667 10.334 32.666 21.999zM67.272 95.858l4.445-5.424v-20h-5.334s-.666 14-.666 15.667.666 7.667.666 7.667M67.383 67.434l-15-.666 4.334-3 10.666-1.667",
    style: {
      fill: "#49728b",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.717 70.768 12.333.333 3-30.667-12.667-1.666z",
    style: {
      fill: "#335061",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.05 70.768 18.667 1s7.666 19.333 7.666 20.333 6.667 28 6.667 28l-15 15.666-3 2.667-8-8v-31z",
    style: {
      fill: "#335061",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.383 73.101-11.666-2.333 1.666-9.334c4.333-2 11.667 3.334 11.667 3.334M130.717 131.434l23.333-17.333.667 8-17.667 16.333z",
    style: {
      fill: "#49728b",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.95 5.098-6.9 28.004-3.433 20.663-.567 15.337 31.234 1.663 19.433.003-1.767-35.003 3-27-.333-5-25.333-2z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.383 71.101s-1.666-34.667 3.334-59.333c0 0-10-6.334-24.667-8l28 1 3.333 2-4 54.666-1 11.668",
    style: {
      fill: "#dcd9d8",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.618 43.098 13 3.667 24.666 1.333 3.667 11.333-6.667 19.667-7.666 1-10.667-3.333-10.234-4.997-5.433.997-4.234-1.664",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.383 49.768s8.666 4 10 3.666l-3.666 18.334 4.333 1.666s3-17.333 3-19.333c0 0 18.666-1 20.333-1 0 0 4 7.667 3 15.667l3.667-10.667.333-6-5.333-8-6-1.333-10 .333-3.333 4.333-11.667-1.666-3.667-1.334",
    style: {
      fill: "#dcd9d8",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.284 73.43-7.333 18.668-7.667 11s1.666 4.667 4 4.667h7.667l7.333-2.667-.666-12.333z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.717 79.768s-9.334 18-9.334 20.666c0 0 1.666 4 4 3s7.334-3.666 7.334-3.666v6.333l-11.334 2.334-7.666-1 13-30.667 2.666-.334",
    style: {
      fill: "#dcd9d8",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.951 123.764-9.234 1.004-8.667 2.667v-3l4.234-4.67 13.334-6",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.05 122.765s10.335-4.334 13.668-3.334l.332-3.996-9.332 1.996-5.667 4z",
    style: {
      fill: "#dcd9d8",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.582 106.63c-5.656.166-10.766.838-15.24 2.1.304 1.834-.265 3.634.192 4.955 1.247.898 3.337.884 5.222 1.095-1.63.801-3.92 1.118-5.801.655-.044 1.273-.615 2.062-.961 3.058 3.18 1.135 10.687 8.576 14.91 6.112 2.012-1.172 2.867-7.866 3.023-11.121.13-2.7-.245-5.424-1.345-6.854",
    style: {
      fill: "#d33833",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.582 106.63c-5.656.166-10.766.838-15.24 2.1.304 1.834-.265 3.634.192 4.955 1.247.898 3.337.884 5.222 1.095-1.63.801-3.92 1.118-5.801.655-.044 1.273-.615 2.062-.961 3.058 3.18 1.135 10.687 8.576 14.91 6.112 2.012-1.172 2.867-7.866 3.023-11.121.13-2.7-.245-5.424-1.345-6.854z",
    style: {
      fill: "none",
      stroke: "#d33833",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.535 115.876q-.024-.642-.05-1.291c-1.766-1.16-4.617-1.146-6.555-2.121 2.857-.125 5.106-.813 7.052-1.783l-.126-3.233c-3.237-2.216-6.194-5.516-10.005-7.594-1.802-.983-8.126-3.512-10.044-3.065-1.084.252-1.182 1.598-1.616 2.867-.923 2.717-3.05 7.042-3.236 11.132-.236 5.166-.758 13.824 4.81 12.76 4.49-.857 9.715-2.926 13.192-4.826 2.125-1.162 3.354-2.598 6.578-2.846",
    style: {
      fill: "#d33833",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.535 115.876q-.024-.642-.05-1.291c-1.766-1.16-4.617-1.146-6.555-2.121 2.857-.125 5.106-.813 7.052-1.783l-.126-3.233c-3.237-2.216-6.194-5.516-10.005-7.594-1.802-.983-8.126-3.512-10.044-3.065-1.084.252-1.182 1.598-1.616 2.867-.923 2.717-3.05 7.042-3.236 11.132-.236 5.166-.758 13.824 4.81 12.76 4.49-.857 9.715-2.926 13.192-4.826 2.125-1.162 3.354-2.598 6.578-2.846z",
    style: {
      fill: "none",
      stroke: "#d33833",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.75 109.712c-.494 2.814-1.065 3.617-.844 6.072 7.505 5.004 8.914-8.595.844-6.072",
    style: {
      fill: "#d33833",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.75 109.712c-.494 2.814-1.065 3.617-.844 6.072 7.505 5.004 8.914-8.595.844-6.072z",
    style: {
      fill: "none",
      stroke: "#d33833",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.617 107.431s-2.334 3.334-.667 4.334 3.334-.001 4.334 1.666 0 2.667.333 4.667 2.001 2.334 3.667 2.667 6.334 1 7-.667l-2 6-4 1.333-12.667-7.333-.667-3.667v-7.333M86.617 96.43c-.4 5.203-.824 10.398-1.296 15.595-.705 7.76 1.865 6.406 8.591 6.406 1.027 0 6.326-1.225 6.705-2 1.818-3.713-3.04-2.888 2.094-5.688 4.334-2.363 11.99 1.435 10.239 6.688-.98 1.168-5.106.364-6.585 1.131l-7.812 4.05c-3.313 1.719-10.971 4.225-14.503 1.823-8.95-6.087.565-21.296 3.757-27.646",
    style: {
      fill: "#ef3d3a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.389 214.532c-9.085 2.116-13.6-3.802-16.354-9.94-2.459.596-1.48 3.94-.86 5.644 1.627 4.472 8.18 10.425 13.535 9.618 2.305-.347 5.423-2.454 3.679-5.322M139.655 204.186l.431-.017c2.053-4.265 3.83-8.783 6.42-12.548-1.735-4.041-13.138-7.617-12.962-.361 2.466 1.078 6.723.22 8.909 1.597-1.264 3.469-3.088 6.422-2.798 11.329M100.04 204.075c1.948-3.571 2.582-7.323 5.351-10.022 1.247-1.215 3.672-2.696 2.47-6.075-.281-.797-2.334-2.574-3.519-2.923-4.329-1.278-14.416-.264-11 5.133 3.58-.167 8.392-2.325 11.068.274-2.055 3.285-5.719 9.784-4.37 13.613M138.03 167.781c-6.518-4.187-13.786-8.74-24.466-7.684-2.282 1.984-3.152 6.399-.935 9.315 1.154-1.984.429-5.633 3.645-6.182 6.06-1.037 13.113 3.707 17.472 5.365 2.703 4.557-.233 6.233-2.668 9.166-4.985 6.009-11.672 13.457-11.429 22.453 2.015 1.461 2.189-2.23 2.478-2.902 2.603-6.092 9.154-13.883 13.935-19.097 1.174-1.284 3.107-2.516 3.322-3.365.62-2.469-1.613-5.427-1.354-7.069M52.102 172.189c-2.043 1.166-2.53 6.302-4.928 6.448-3.428.208-2.803-6.663-2.79-10.681-2.359 2.142-2.774 8.737-1.04 12.124-1.976.97-2.858-1.07-3.953-1.789 1.408 10.23 14.965 4.745 12.71-6.102M142.18 163.521c-3.034-5.775-7.326-12.135-16.229-12.32-.181 1.865-.32 4.703.01 5.826 6.806.654 11.008 4.118 16.219 6.494M99.527 159.777c5.678-2.986 16.114-3.307 23.832-3.081.414-1.691.404-3.78.42-5.842-9.921-.495-21.651 1.96-24.252 8.923M98.447 154.209c3.927-9.859 17.423-8.724 28.804-8.452-.501-1.28-1.587-2.792-2.937-3.339-3.647-1.484-13.706-2.61-18.769.079-3.211 1.707-5.274 5.564-7.033 7.825-.85 1.092-5.08 3.881-.065 3.887",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.556 99.826c-4.608-7.892-9.017-15.998-14.484-22.96 2.292 6.74 3.273 18.02 3.619 26.618 4.795 2.244 8.901-.505 10.865-3.658",
    style: {
      fill: "#81b0c4",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.352 71.46c-5.159-1.032-8.784-6.046-13.817-5.724 2.766 3.9 7.613 5.543 13.817 5.725M164.628 63.387c-4.205-.444-9.144-1.125-13.409-.774 2.019 3.084 9.798 2.02 13.409.774M166.085 56.426c-4.726-.102-10.6-.008-15.092.369 2.657 2.854 12.027 1.059 15.092-.369",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.664 37.377c.678-5.935 3.031-11.949 2.736-18.449-2.613-.881-4.114-1.652-7.615-1.647-.247 5.524-.986 13.969-.765 19.235 1.722-.114 4.261 1.23 5.644.861",
    style: {
      fill: "#dcd9d8",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.045 124.849c-2.373-1.549-4.394-3.483-6.673-5.137-5.054-.25-7.812.35-11.525 3.252.061.233.434.129.448.415 5.41-2.411 12.287.982 17.75 1.47",
    style: {
      fill: "#f0d6b7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.645 87.971c1.486 6.441 7.31 9.777 12.599 13.324 5.459-6.928 8.779-15.838 12.435-24.436-8.638 2.604-17.464 6.829-25.034 11.112",
    style: {
      fill: "#81b0c4",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.02 36.516c-.221-5.266.518-13.71.765-19.235 3.501-.005 5.002.766 7.615 1.647.295 6.5-2.058 12.514-2.736 18.449-1.383.37-3.922-.975-5.644-.861M68.506 66.465C70.814 45.242 74.158 27.4 80.29 8.608c13.611-4.133 30.02-4.493 42.051-.764-2.209 10.607-1.244 23.52-2.535 34.84-.973 8.508-.477 17.068-1.811 25.748-14.578 3.033-35.183.709-49.49-1.967m52.937 1.834c-.123-9.115.408-18.106 1.104-27.232 3.5.525 5.875.876 9.127 1.589-1.056 8.786-.926 18.672-3.077 26.444-2.486-.024-4.675.029-7.154-.801m17.755 1.469c-1.661.38-3.595.015-5.182-.016.746-7.43 2.556-15.629 3.193-23.428 2.497-.078 3.831 1.1 5.885 1.496.11 6.846-.598 16.278-3.896 21.948m26.884-24.563c5.205 1.264 8.478 7.64 7.022 14.186-.977 4.4-2.717 12.685-4.579 15.5-1.376 2.082-5.107 4.808-8.086 2.9-4.846-3.103-13.383-4.004-16.917-7.76 1.772-5.9 2.322-14.004 3.053-21.48 6.054-.377 13.503 1.666 18.538-.502-3.515-1.139-8.076-1.148-11.113-2.807 2.482-1.199 8.293-.957 12.082-.037M117.679 76.86c-3.656 8.598-6.976 17.508-12.435 24.436-5.289-3.547-11.113-6.883-12.6-13.324 7.571-4.283 16.397-8.508 25.035-11.112m9.012 26.625c-.346-8.599-1.327-19.878-3.619-26.617 5.467 6.961 9.876 15.067 14.484 22.96-1.964 3.152-6.07 5.901-10.865 3.657m-10.216 3.63c-2.071.223-3.829-2.381-6.522-1.255-.617-.682-1.178-1.421-1.807-2.087 5.948-7.168 8.651-17.338 13.245-25.762 2.465 8.092 2.181 16.957 2.724 25.789-3.387-.215-5.266 3.063-7.64 3.315m-6.569 8.67c-.221-2.455.35-3.258.844-6.072 8.07-2.523 6.661 11.076-.844 6.072m-8.949 2.938c-3.477 1.9-8.701 3.969-13.192 4.826-5.568 1.065-5.046-7.594-4.81-12.76.186-4.09 2.313-8.415 3.236-11.132.434-1.269.532-2.615 1.616-2.867 1.918-.447 8.242 2.082 10.044 3.065 3.811 2.078 6.768 5.378 10.005 7.594l.126 3.233c-1.946.97-4.195 1.658-7.052 1.783 1.938.975 4.789.961 6.555 2.121q.026.649.05 1.291c-3.224.248-4.453 1.684-6.578 2.846m-33.214 6.033c-2.886-2.93 8.095-6.924 11.591-7.139-.02 1.854 1.057 3.602.84 4.932-4.153.729-9.61.248-12.43 2.207m35.552-1.376c-.014-.286-.387-.182-.448-.415 3.713-2.902 6.471-3.502 11.525-3.252 2.279 1.654 4.3 3.588 6.673 5.137-5.463-.488-12.34-3.881-17.75-1.47m32.632-9.895c-.156 3.255-1.011 9.949-3.023 11.121-4.223 2.465-11.73-4.977-14.91-6.112.346-.996.917-1.785.961-3.058 1.881.463 4.171.146 5.801-.655-1.885-.211-3.975-.197-5.222-1.095-.457-1.321.112-3.121-.192-4.955 4.474-1.262 9.584-1.934 15.24-2.1 1.1 1.43 1.475 4.154 1.345 6.854m-73.042 8.437c-.906.646-7.037 8.623-7.877 8.292-11.094-4.375-21.467-11.94-30.737-19.095C33.11 92.154 36.678 68.92 37.308 46.526c10.125-4.735 19.017-11.561 32.755-12.274-1.59 11.248-3.04 21.283-3.943 31.873-3.452 1.455-8.404-.066-11.635.451-.027 3.893 4.934 1.705 5.347 4.323.312 1.98-2.73 2.13-1.74 5.248 2.526-.918 3.852-2.946 6.546-3.707 2.46 5.384-.035 14.91.32 19.41.067.845.422 4.68 2.315 4.008 1.674-.596-.096-10.202.087-14.461.168-3.924-.473-7.72 1.116-10.184a379 379 0 0 0 41.129 3.369c-3.16 1.356-6.914 2.64-11.03 4.959-2.231 1.258-9.264 3.875-9.908 5.994-1.027 3.377 2.695 5.176 3.332 8.07-6.701-3.654-8.008 3.504-9.594 8.575-1.436 4.593-2.254 8.024-2.606 10.673-5.773 2.752-11.944 5.539-16.913 9.068m67.179 7.327c9.243 4.482 10.909-16.751 7.286-23.591.56-2.04 2.486-2.821 3.272-4.655-5.158-9.24-10.887-17.865-16.15-26.996 3.915 2.437 9.507.436 14.114 2.26 1.684.666 2.903 4.521 4.178 7.605 3.507 8.485 7.189 19.182 8.827 27.279.37 1.845 1.378 5.865 1.152 7.507-.403 2.94-4.392 5.12-6.421 6.938-3.738 3.358-6.092 6.313-9.991 9.453-1.581-2.334-4.974-3.902-6.267-5.8m-88.318 81.968c-4.404-4.846-3.482-13.926-2.95-20.386 7.962 5.008 18.528-.396 18.429-8.914 3.8.101 1.42 4.747.732 7.74-2.247 9.776 3.785 20.397.274 29.337-6.819-.517-12.42-3.302-16.485-7.777m31.514 28.126c-9.97-2.826-22.75-10.071-26.847-19.028 3.173.461 5.375 2.061 8.505 2.259 1.183.077 2.732-.496 4.092-.158 2.709.672 4.995 6.746 7.039 9.006 1.992 2.207 4.387 3.15 6.025 5.162 1.053.508 2.61.473 2.67 2.054-.457.488-.937.86-1.484.705m51.903-2.658c-10.349 5.839-27.866 10.231-38.875 4.743-8.882-4.429-20.89-11.757-24.983-21.043 3.824-8.961-1.133-17.172-1.45-26.27-.167-4.841 2.28-9.067 2.467-14.337-1.308-2.159-5.306-2.425-8.074-2.277-.932 4.662-2.562 9.902-7.363 10.428-6.793.743-11.76-4.879-12.069-10.754-.365-6.909 5.307-18.36 13.346-17.565 3.106.307 3.869 3.42 7.252 3.388 1.834-3.659-2.829-4.808-3.308-7.425-.125-.676.386-3.318.684-4.557 1.46-6.033 4.715-13.841 7.919-18.434 4.066-5.826 12.056-6.704 20.65-7.275 1.536 3.307 7.19 3.035 10.875 2.17-4.416 1.749-8.521 5.989-11.923 9.742-3.909 4.306-7.868 8.925-8.068 14.553 7.386-10.246 13.488-19.194 26.917-23.701 10.162-3.408 22.03 1.562 29.838 7.045 3.24 2.279 5.174 5.895 7.477 9.205 8.617 12.395 12.638 30.087 11.754 47.235-.364 7.072-.348 14.12-2.721 18.878-2.48 4.975-10.868 9.426-15.778 4.926-.91 4.838 4.083 7.83 9.948 6.089-4.182 5.397-8.571 11.882-14.515 15.236m19.281-159.567c8.087 4.02 23.197 10.82 28.267-.015 1.871-3.994 4.066-10.746 5.035-14.87 1.369-5.816-1.484-18.042-7.463-19.994-5.281-1.724-11.443-1.619-17.804-.341-.749.623-1.583 1.709-2.166 2.84-4.542.177-8.795-.243-12.383-2.11.34-3.359-1.932-3.898-4.062-4.59-1.579-6.26 3.159-14.437 2.025-20.146-.809-4.067-5.813-4.696-9.491-5.457-.12-2.26.161-4.147.412-6.059-.841-3.099-4.613-4.863-8.187-5.295C106.868-.334 89.014-.97 77.703 3.098c-3.156 7.742-5.643 17.158-8.271 25.998-11.032-1.178-19.954 4.76-28.364 8.65-2.913 1.35-6.941 2.094-8.029 4.412-1.055 2.244-.623 6.545-.885 10.608-.666 10.377-1.236 20.386-3.976 31.011-1.23 4.768-3.375 8.975-4.871 13.57-1.383 4.257-3.8 9.519-4.43 13.765-.934 6.293 4.992 6.643 8.781 9.37 5.858 4.217 10.455 6.549 16.799 10.355 1.879 1.127 7.545 3.98 8.19 5.294 1.28 2.605-2.2 6.278-3.13 8.32-1.472 3.229-2.24 5.972-2.45 9.158-5.322.841-9.356 4.008-11.793 7.579-4.03 5.91-6.826 16.844-3.339 25.161.274.655 1.638 1.943 1.84 2.949.396 1.981-.748 4.615-.819 6.722-.366 10.81 1.83 20.124 9.106 23.384 2.955 11.769 13.529 15.682 23.49 21.531 3.725 2.186 7.83 3.583 12.07 5.143 15.207 5.597 38.541 4.543 51.163-5.003 5.352-4.048 13.907-12.595 16.967-18.783 8.082-16.337 7.508-43.64 1.855-63.513-.76-2.668-1.862-6.59-3.401-9.795-1.073-2.238-4.408-6.716-4.003-8.692.417-2.043 7.604-7.5 9.145-8.986 2.775-2.677 8.047-6.23 8.474-9.608.459-3.595-1.584-8.513-2.619-11.982-3.46-11.577-6.836-22.278-10.759-32.6",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.491 157.255c.439.584 2.85 1.471 6.226-.154 0 0-4-.667-3.667-7.336l-1.667.334s-1.723 6.047-.892 7.156",
    style: {
      fill: "#f7e4cd",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.717 99.934a1.833 1.833 0 1 0-3.667.001 1.833 1.833 0 0 0 3.667-.001M121.55 91.434a1.833 1.833 0 1 0-3.667.001 1.833 1.833 0 0 0 3.667-.001",
    style: {
      fill: "#1d1919",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 312)"
  }));
};
export default SvgJenkins;